import script from "./ViewShipment.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewShipment.vue?vue&type=script&setup=true&lang=js"

import "./ViewShipment.vue?vue&type=style&index=0&id=c9098a58&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9098a58"]])

export default __exports__